import { z } from 'zod';

// Schema for sign-in with password
export function createSignInWithPasswordSchema(messages: {
  emailRequired: string;
  emailInvalid: string;
  passwordRequired: string;
  passwordMinLength: string;
}) {
  return z.object({
    email: z
      .string()
      .min(1, messages.emailRequired)
      .email(messages.emailInvalid),
    password: z
      .string()
      .min(1, messages.passwordRequired)
      .min(6, messages.passwordMinLength),
  });
}

export const signInWithPasswordSchema = z.object({
  email: z
    .string()
    .min(1)
    .email(),
  password: z
    .string()
    .min(1)
    .min(6),
});

export type SignInWithPasswordFormFields = z.infer<typeof signInWithPasswordSchema>;
